import React, { useContext } from "react";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";
import HeadTags from "components/HeadTags";

const RequestPricing = () => {
  const { config } = useContext(StoreContext);
  // const sku = localStorage.getItem("sku");
  // const name = localStorage.getItem("name");
  // document.getElementById(
  //   "152971_120105pi_152971_120105"
  // ).innerHTML = `${name} - ${sku}`;

  // const locationName = window.location.href.indexOf("name=");
  // const locationSku = window.location.href.indexOf("sku=");

  // const name = window.location.href.slice(locationName + 1, locationSku);
  // const sku = window.location.href.slice(
  //   locationSku + 1,
  //   window.location.href.length
  // );

  // document.getElementById(
  //   "152971_120105pi_152971_120105"
  // ).innerHTML = `${name} - ${sku}`;

  if (config.loaded) {
    return (
      <>
        <HeadTags title="Request Pricing" />
        <div className="contentPage">
          <div className="contentPage__headingDiv">
            <h1>Request Pricing</h1>
            <h6>
              Looking to purchase for an organization? Send us a message and a
              HealthStream representative will be in touch as soon as possible
            </h6>
          </div>
          <div className="contentPage__requestPricingBlock">
            <iframe
              title="Enterprise Pricing"
              src={config.requestPricingPardotForm}
            />
          </div>
        </div>
      </>
    );
  }
  return <Loading />;
};

export default RequestPricing;
